var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketing = function SvgMarketing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m6.735 16-.01 5.12c-.005 2.047.252 3.632 1.048 5.152s1.98 2.706 3.395 3.397a6.53 6.53 0 0 0 4.51.468"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.1 9.244C3.292 7.974 4.919 7.25 6.626 7.25H10a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H6.625c-1.707 0-3.334-.724-4.524-1.994S.25 15.774.25 14s.661-3.486 1.85-4.756",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.93.338a1.545 1.545 0 0 1 1.82 1.52v24.784a1.545 1.545 0 0 1-2.612 1.118C18.851 23.668 13.93 20.75 9 20.75h-.75V7.25H9c4.965 0 9.889-2.454 14.138-6.509m.792-.403a1.55 1.55 0 0 0-.792.403Z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.5 10v11"
  })));
};
export default SvgMarketing;